import { observer } from 'mobx-react-lite';
import { DATA } from '../../game/data';
import { COLORS } from '../../game/data/colors';
import { formatNumber } from '../../game/helpers';

export const MoneyCounter: React.FC = observer(() => {
  return (
    <div
      style={{
        zIndex: 10000,
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        top: 8,
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '4px',
        backgroundColor: COLORS.zinc_700,
        fontSize: '1.4rem',
        fontWeight: 600,
        minWidth: 100,
        textAlign: 'center',
      }}
    >
      <span style={{ color: COLORS.green_500 }}>$</span>
      {formatNumber(DATA.money)}
    </div>
  );
});
